import { useCategories, useGenres } from '@bpm-web-app/swr-hooks';
import { useContext, useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import CategoriesGrid, { GridElement } from '../../categories-grid/categories-grid';
import { LibraryTabsContext } from '../../../../../utils/src/lib/library-tabs.context';
import PrimaryPageTitle from '../../shared/primary-page-title/primary-page-title';
import styles from './genres.module.css';
import { SearchInput } from '../../shared/search-input/search-input';
import { BreakpointView } from '../../shared';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface GenresProps { }

export function Genres(props: GenresProps) {
    const { libraryProperty } = useContext(LibraryTabsContext);
    const { categories, isLoading: isCategoriesLoading } = useCategories(libraryProperty);
    const { genres, isLoading: isGenresLoading } = useGenres(libraryProperty);
    const [searchQuery, setSearchQuery] = useState<string>('');
    const [filteredGenres, setFilteredGenres] = useState<Array<GridElement>>();

    useEffect(() => {
        let newGenres = genres;
        if (searchQuery) {
            newGenres = newGenres?.filter((genre) => genre.slug.toLowerCase().includes(searchQuery.toLowerCase()));
        }

        setFilteredGenres(newGenres?.map(({ id, name, slug }) => ({ id, name, href: `/genres?genre=${slug}`, isFilterLink: true })));
    }, [genres, searchQuery]);

    const categoriesArr: Array<GridElement> = useMemo(
        () =>
            (categories || []).map(({ id, name, slug, icon_svg }) => ({
                id,
                name,
                href: `/genres?category=${slug}`,
                isFilterLink: true,
                icon: icon_svg
            })),
        [categories]
    );

    const isEverythingLoaded = useMemo(() => {
        if (
            !isGenresLoading &&
            !isCategoriesLoading
        ) return true;
        return false;
    }, [isCategoriesLoading, isGenresLoading]);

    return (
        // eslint-disable-next-line @typescript-eslint/dot-notation
        <section className={classNames(styles['genres'], 'spacing__window')}>
            <div>
                <BreakpointView
                    mobileChildren={
                        <>
                            <div className={styles['genres__header']}>
                                <div className={styles['genres__title']}>
                                    <PrimaryPageTitle title="Genres" noPadding />
                                </div>
                                <SearchInput
                                    placeholder="Search Genres"
                                    value={searchQuery}
                                    variant="small"
                                    onChange={(e) => {
                                        setSearchQuery(e.target.value);
                                    }}
                                    onClear={() => setSearchQuery('')}
                                />
                            </div>
                            {searchQuery
                                ? null : <CategoriesGrid title="Categories" elements={categoriesArr} isLoading={!isEverythingLoaded} genreVariant="has-icon" />}

                        </>
                    }
                    desktopChildren={(
                        <>
                            <div className={styles['genres__header']}>
                                <div className={styles['genres__title']}>
                                    <PrimaryPageTitle title="Categories" noPadding />
                                </div>
                            </div>
                            <CategoriesGrid elements={categoriesArr.slice(0, 3)} isLoading={!isEverythingLoaded} genreVariant="has-icon" gridVariant="wide" ghostElementsCount={3} />
                            <CategoriesGrid elements={categoriesArr.slice(3)} isLoading={!isEverythingLoaded} genreVariant="has-icon" gridVariant="narrow" />
                        </>
                    )}
                />

                <BreakpointView
                    mobileChildren={
                        <CategoriesGrid title={searchQuery ? '' : 'Genres'} elements={filteredGenres} isLoading={!isEverythingLoaded} />
                    }
                    desktopChildren={
                        <CategoriesGrid title="Genres" elements={filteredGenres} isLoading={!isEverythingLoaded} hasSearch searchPlaceholder="Search Genres" searchTerm={searchQuery} setSearchTerm={setSearchQuery} gridVariant="medium" />
                    }
                />
            </div>
        </section>
    );
}

export default Genres;
